import Icon from '../Icon';
import { logo } from '../../assets/images/images';

function Services() {
  return (
    <div className='px-[2rem] lg:py-[2rem] lg:px-[9.5rem]'>
      <div className='w-full text-center mb-10 font-[700] text-[#358280] font-SourceSerif text-4xl xl:text-5xl'>
        <h1>Services</h1>
      </div>

      <div className='grid grid-cols-4 gap-16 md:gap-4 items-center'>
        <div className='col-start-1 col-end-5 sm:col-start-1 sm:col-end-3 md:col-start-1 md:col-span-1'>
          <div className='rounded-lg my-0 mx-auto mb-4 w-[9rem] h-[9rem] md:w-[5.6rem] md:h-[5.6rem] bg-[#FFF2F2] p-2 flex items-center justify-center'>
            <Icon name='spoons' className='w-10' />
          </div>

          <h2 className='text-[500] text-2xl text-center'>Food</h2>
          <p className='text-greySecondary text-center text-base'>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
          </p>
        </div>
        <div className='col-start-1 col-end-5 sm:col-start-3 sm:col-end-5 md:col-start-2 md:col-span-1'>
          <div className='rounded-lg my-0 mx-auto mb-4 w-[9rem] h-[9rem] md:w-[5.6rem] md:h-[5.6rem] bg-[#FDFBDA] p-2 flex items-center justify-center'>
            <img src={logo} alt='logo' className='w-10 block' />
          </div>

          <h2 className='text-[500] text-2xl text-center'>Restaurant</h2>
          <p className='text-greySecondary text-center text-base'>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
          </p>
        </div>
        <div className='col-start-1 col-end-5 sm:col-start-1 sm:col-end-3 md:col-start-3 md:col-span-1'>
          <div className='rounded-lg my-0 mx-auto mb-4 w-[9rem] h-[9rem] md:w-[5.6rem] md:h-[5.6rem] bg-[#E2F3FF] p-2 flex items-center justify-center'>
            <Icon name='scooty' className='w-10' />
          </div>

          <h2 className='text-[500] text-2xl text-center'>Delivery</h2>
          <p className='text-greySecondary text-center text-base'>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
          </p>
        </div>
        <div className='col-start-1 col-end-5 sm:col-start-3 sm:col-end-5 md:col-start-4 md:col-span-1'>
          <div className='rounded-lg my-0 mx-auto mb-4 w-[9rem] h-[9rem] md:w-[5.6rem] md:h-[5.6rem] bg-[#FFE7FB] p-2 flex items-center justify-center'>
            <Icon name='twoPerson' className='w-10' />
          </div>

          <h2 className='text-[500] text-2xl text-center'>Reservation</h2>
          <p className='text-greySecondary text-center text-base'>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
          </p>
        </div>
      </div>
    </div>
  );
}

export default Services;
